import React, { useState } from 'react';
import { classes } from '../CUtil';
import ActionLink from './ActionLink';

/* Call from your render() method; it registers state via useState(), so it
 * expects to be in the scope of your Component.
 *
 * Usage:
 *
 *   // your raw row data; you iterate this to render the table rows
 *   const rows = [
 *      {foo_value: 42, bar_value: 666},
 *      {foo_value: 420, bar_value: 69},
 *      ...
 *   ];
 *
 *   // initialize SortMagic; passed object must have an entry for every column
 *   // key ("foo" and "bar"), and define a "key" function that extracts a
 *   // number value to sort by
 *   const SM SortMagic({
 *      foo: {key: x => x.foo_value},
 *      bar: {key: x => x.bar_value},
 *   });
 *
 *   // render rows
 *   for (const row of SM.sort(rows)) {
 *      // ...
 *   }
 *
 *   // when creating your table header:
 *   .......
 *       <thead>
 *            <SM.Th colkey="foo">click me to sort by 'foo'</SM.Th>
 *            <th>columns don't have to be sortable</th>
 *            <SM.Th colkey="bar">click me to sort by 'bar'</SM.Th>
 *       </thead>
 *   .......
 */
function SortMagic(columns) {
	const [ sort_by, set_sort_by ] = useState(null);

	return {
		sort: (xs) => {
			if (sort_by !== null) {
				const [ colkey, order ] = sort_by;
				const column = columns[colkey];
				const sign = [-1,1][order];
				xs = [...xs];
				xs.sort((a,b) => sign * (column.key(a) - column.key(b)));
			}
			return xs;
		},

		Th: (props) => {
			var pprops = {...props};
			delete pprops.children;
			delete pprops.colkey;
			delete pprops.className;
			const cls = classes(props.className, "ad_no_select");
			const colkey = props.colkey;
			const click = () => {
				if (sort_by === null || sort_by[0] !== colkey) {
					set_sort_by([colkey, 0]);
				} else if (sort_by[1] === 0) {
					set_sort_by([colkey, 1]);
				} else {
					set_sort_by(null);
				}
			};

			var arrow;
			if (sort_by && sort_by[0] === colkey) {
				if (sort_by[1] === 0) {
					arrow = <span>&darr; </span>
				} else if (sort_by[1] === 1) {
					arrow = <span>&uarr; </span>
				}
			}

			return <th className={cls} {...pprops}><ActionLink on_click={click}>{props.children} {arrow}</ActionLink></th>
		},
	};
}

export {
	SortMagic,
}



// WEBPACK FOOTER //
// ./src/c/Tables.js